import axiosInstance from '../../core/axiosConfig';

interface SendPromotionPayload {
  locationId: number;
  title: string;
  body: string;
}

export class PromotionService {
  async sendPromotion(payload: SendPromotionPayload) {
    await axiosInstance.post('/promotion/send', payload);
  }
}
